module.exports = __webpack_public_path__ + "assets/643470710a60fdc4a1c3df732b114ef5.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-greek-ext-500-normal.woff2
// module id = 2632
// module chunks = 121